import { autobind } from 'core-decorators';

import { IFeatureEntry } from 'shared/types/app';

import { connectEntryToStore } from './store'

type FeatureLoader = () => Promise<IFeatureEntry>;
type FeaturesLoaders = Record<string, FeatureLoader>;

class AsyncFeaturesManager {
  private features = new Map<string, IFeatureEntry>();

  @autobind
  public async loadFeatures(loaders: FeaturesLoaders) {
    const featuresNames = Object.keys(loaders);

    return Promise.all(
      featuresNames.map(featureName => loaders[featureName]().then(bundle => {
        bundle.reduxEntry && connectEntryToStore(bundle.reduxEntry);
        this.features.set(featureName, bundle);
      })),
    );
  }

  @autobind
  public getFeaturesEntries(featuresNames: string[]): Record<string, IFeatureEntry> {
    return featuresNames.reduce((acc, featureName) => ({
      ...acc,
      [featureName]: this.features.get(featureName),
    }), {});
  }
}

const asyncFeaturesManager = new AsyncFeaturesManager();

export { asyncFeaturesManager };
